import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from "react-intl";
import {Label} from "semantic-ui-react";
import BasicModal from "../../components/common/BasicModal";
import config from "./manual-entry-config";
import compose from "recompose/compose";
import setDisplayName from "recompose/setDisplayName";
import {formDataManager} from "../../hoc/formDataManager";
import {makeFormFactory} from "../../utils/helpers";
import {isUndefined, get, every} from "lodash";
import {endManualEntryAction, submitManualEntryAction} from "./actions";
import BreakSearchInput from "./BreakSearchInput";
import BasicFormComponents from "../../components/forms/Component Sets/BasicFormComponents";
import {createResourceSelector} from "../../resources/selectors";
import {isNoU} from "../../utils/DBUtils";

const components = {
    ...BasicFormComponents,
    breakSearch: BreakSearchInput
};

const Form = makeFormFactory(components)(config);

const ManualEntryModal = (props) => {
    return (
        <BasicModal
            header={<FormattedMessage id='prizes.manual.entry.title' />}
            specialType='primary-modal create-user-modal'
            actions={[
                {
                    label: <FormattedMessage id='prizes.manual.entry.cancel' />,
                    action: props.onClose,
                    displayType: 'menu-item'
                },
                {
                    label: <FormattedMessage id='prizes.manual.entry.submit' />,
                    loading: props.inFlight,
                    isDisabled: !props.canSubmit,
                    action: props.submit,
                    displayType: 'button',
                    primaryCheck: true
                }
            ]}
            open={props.isOpen}
            onClose={props.onClose}>
            <div className={"manual-entry-form"}>
                <Form
                    onValueChanged={props.onValueChanged}
                    onValidationError={props.onValidationError}
                    errors={props.errors}
                    data={props.formData} />
                {false && (
                    <Label basic className='db-error-label password-mismatch-indicator'>
                        <FormattedMessage id='errors.validation.password_mismatch' />
                    </Label>
                )}
            </div>
        </BasicModal>
    );
};

const mapState = ({listEntries}, {formData, hasErrors}) => {
    let {submittingManualEntry, manualEntryModalOpen} = listEntries;
    let allFieldsDefined = every(config.fields
        .filter((f) => get(f, "props.required", false) === true)
        .map((f) => !isUndefined(formData[f.name])));
    return {
        errors: [],
        isOpen: manualEntryModalOpen,
        canSubmit: allFieldsDefined && !hasErrors,
        inFlight: submittingManualEntry
    };
};

const mapDispatch = (dispatch) => {
    return {
        onClose: () => dispatch(endManualEntryAction())
    };
};

export default compose(
    connect(({listEntries, resources}) => {
        const {currentPrizeId} = listEntries;
        const getPrize = createResourceSelector(currentPrizeId);
        const currentPrize = getPrize(resources);

        // only initialize data if prize exists so form data manager knows to update
        let data;
        if (!isNoU(currentPrize)) {
            data = {
                type: currentPrize.type
            };
        }

        return {
            data
        }
    }, (dispatch) => ({
        onSaveData: (data) => dispatch(submitManualEntryAction(data))
    })),
    formDataManager({}, config),
    connect(mapState, mapDispatch),
    setDisplayName('ManualEntryModal')
)(ManualEntryModal);


// WEBPACK FOOTER //
// ./public/pages/ListEntries/ManualEntryModal.jsx